

















import Vue from 'vue'
import Component from 'vue-class-component'
import ImageDialog from '@/main/image-dialog/image-dialog.vue'
import ConfirmationDialog from '@/shared/components/confirmation-dialog.vue'
import { TokenHolder } from '@/shared/utils/token-holder'
import { Injector } from '@/config/dependency-injection'
import { AuthenticationModule } from '@/authentication/store/authentication-module'
import InfoDialog from '@/shared/components/info-dialog.vue'
import { DialogService } from '@/shared/dialog/dialog-service'
import { VueRouter } from 'vue-router/types/router'
import { RouterToken } from '@/config/injection-tokens'
import CookieConsent from '@/main/cookie-consent.vue'
import DevelopmentSettingsToggle from '@/shared/development/components/development-settings-toggle.vue'
import RespondecoDialogContainer from '@/shared/dialog/respondeco-dialog-container.vue'
import RespondecoDropArea from '@/shared/components/respondeco-drop-area.vue'
import { isUser } from '@/shared/utils/user'
import { Watch } from 'vue-property-decorator'
import { Account } from '@/api/generated'
import { DragAndDropService } from '@/shared/services/drop-file/drag-and-drop-service'

@Component({
  components: {
    RespondecoDropArea,
    RespondecoDialogContainer,
    DevelopmentSettingsToggle,
    ConfirmationDialog,
    ImageDialog,
    InfoDialog,
    CookieConsent,
  },
})
export default class App extends Vue {
  private authenticationModule: AuthenticationModule = Injector.get(AuthenticationModule)
  private dialogService = Injector.get(DialogService)
  private dragAndDropService = Injector.get(DragAndDropService)
  private router: VueRouter = Injector.get(RouterToken)
  private tokenHolder: TokenHolder = Injector.get(TokenHolder)

  get activeUser() {
    return this.authenticationModule.authenticatedUser
  }

  get userIsAuthenticated() {
    return isUser(this.activeUser)
  }

  public mounted() {
    if (this.tokenHolder.hasToken()) {
      this.authenticationModule.fetchLogin()
    }

    const query = this.router.currentRoute.query || {}

    if (query.hasOwnProperty('from-www')) {
      this.dialogService.info(
        'Willkommen auf respondeco.org!',
        'Dies ist eine vorläufige Testversion, Sie wurden hierher umgeleitet da sich unsere Webseite noch im Aufbau befindet.'
      )

      delete query['from-www']

      this.router.replace({
        ...this.router.currentRoute,
        name: this.router.currentRoute.name ?? undefined,
        query: {
          'from-www': undefined,
        },
      })
    }
  }

  @Watch('activeUser')
  private onActiveUserChanged(account: Account) {
    if (isUser(account)) {
      this.dragAndDropService.start()
    } else {
      this.dragAndDropService.end()
    }
  }
}
